// Single source of truth for responsive breakpoints.
//
// `useIsMobile()` treats widths below `md` (768px) as mobile, i.e. the JS query
// is `(min-width: 768px)`. The exact CSS complement is `(max-width: 767.98px)`
// — so **CSS mobile rules must use `@media (max-width: 767.98px)`** to flip at
// the same pixel as the JS hook (a plain `767px` leaves a 1px desktop/mobile
// mismatch). Keep CSS `@media` values in sync with the numbers here.
//
// (True single-sourcing into CSS would need a PostCSS custom-media plugin in
// the ejected webpack config; until then this comment is the contract.)
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

// Ready-made media query strings for use with useMediaQuery.
export const MEDIA = {
  smUp: `(min-width: ${BREAKPOINTS.sm}px)`,
  mdUp: `(min-width: ${BREAKPOINTS.md}px)`,
  lgUp: `(min-width: ${BREAKPOINTS.lg}px)`,
  xlUp: `(min-width: ${BREAKPOINTS.xl}px)`,
  // Mobile: complement of mdUp. Mirrors the CSS `@media (max-width: 767.98px)`.
  mdDown: `(max-width: ${BREAKPOINTS.md - 0.02}px)`,
} as const;
